<!--
  * name: brand story
  * description: [Main] brand story 컴포넌트 페이지
-->
<template>
  <div>
    <bread-crumb location="brand story"></bread-crumb>
    <!-- 병헌 : 경로 -->
    <section-1 />
    <section-2 />
    <section-3 />
    <section-4 />
    <section-5 :productList="productList"/>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';
// eslint-disable-next-line import/no-extraneous-dependencies
// import AOS from 'aos';
// import '@/assets/plugins/aos.css';;
import productApi from '@/apis/product';
import BreadCrumb from '@/components/breadcrumb/BreadCrumb.vue';
import Section1 from './partial/Section1.vue';
import Section2 from './partial/Section2.vue';
import Section3 from './partial/Section3.vue';
import Section4 from './partial/Section4.vue';
import Section5 from './partial/Section5.vue';

export default {
  name: 'BrandStory',
  components: {
    BreadCrumb,
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
  },
  data() {
    return {
      productList: [],
    };
  },
  created() {
    this.getProductList();
  },
  methods: {
    async getProductList() {
      const result = await productApi.getProducts();
      if (!result.error) {
        this.productList = result;
      }
    },
  },
  // created() {
  //   AOS.init();
  // },
};
</script>

<style lang='scss' scoped>
@import '@/assets/css/brandstory.scss';
</style>
